import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Sync as SyncIcon,
  People as PeopleIcon
} from '@mui/icons-material';

function ComponentSelector() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/pricing-sync/pricing')) return 1;
    if (path.includes('/pricing-sync/settings')) return 2;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = React.useState(getActiveTabFromPath());

  // Update active tab when location changes
  React.useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    // Navigate to the corresponding route
    switch (newValue) {
    case 0:
      navigate('/pricing-sync/operations');
      break;
    case 1:
      navigate('/pricing-sync/pricing');
      break;
    case 2:
      navigate('/pricing-sync/settings');
      break;
    default:
      navigate('/pricing-sync/operations');
    }
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab icon={<SyncIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Operations" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<PeopleIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Price Rules" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<SettingsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Settings" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
        </Tabs>
      </Paper>
    </Box>
  );
}

export default ComponentSelector;
